import { Typography } from '@mui/material';

export function IncomeReportsContent() {
  return (
    <Typography variant="text">
      Para acessar o{' '}
      <Typography variant="text" fontWeight={700}>
        Informe de rendimentos
      </Typography>
      , clique em “Acessar portal” para ser direcionado para uma nova página.
    </Typography>
  );
}
